export var COMPONENT_NAME_PREFIX = 'tcw-';
export var KEYSTROKE_DEBOUNCE_THRESHOLD = 500;
export var ICON_CLASS_NAME = 'tyler-icons';
export var CDN_BASE_URL = 'https://cdn.forge.tylertech.com/';
export var POPUP_DIALOG_WIDTH_THRESHOLD = 599;
export var VERSION = '1.13.0';
